import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import MapViewState from "@mapmycustomers/shared/types/viewModel/MapViewState";

import { NO_CONTACT_IN_ENTITY_TYPES } from "@app/scene/dashboard/components/cards/NoContactIn/consts";
import NoContactInCardConfiguration from "@app/types/dashboard/cards/noContactIn/NoContactInCardConfiguration";
import Scope from "@app/types/dashboard/Scope";

const createMapViewStateFromConfiguration = (
  { criteria, dateRange }: NoContactInCardConfiguration,
  scope: Scope
): Partial<MapViewState> => ({
  filter: {
    universal: {
      noContactDaysOut: {
        operator: dateRange.days === null ? FilterOperator.EMPTY : FilterOperator.GREATER_THAN,
        value: dateRange.days,
      },
      ...(criteria.sources.length
        ? {
            sourceCreated: {
              operator: FilterOperator.IN_ANY,
              value: criteria.sources,
            },
          }
        : {}),
      ...(scope.teamId && !scope.userId
        ? {
            team: {
              operator: FilterOperator.IN_ANY,
              value: [scope.teamId],
            },
          }
        : {}),
      ...(scope.userId
        ? {
            user: {
              operator: FilterOperator.IN_ANY,
              value: [scope.userId],
            },
          }
        : {}),
      // ...(criteria.frequencyStatus && criteria.frequencyStatus.length === 1
      //   ? {
      //       cadenceStatus: {
      //         operator:
      //           criteria.frequencyStatus[0] === FrequencyStatusType.UNKNOWN
      //             ? FilterOperator.EQUALS
      //             : FilterOperator.NOT_EQUAL,
      //         value: FrequencyStatusType.UNKNOWN,
      //       },
      //     }
      //   : {}),
    },
  },
  visibleEntities: criteria.entityTypes.length
    ? criteria.entityTypes
    : [...NO_CONTACT_IN_ENTITY_TYPES],
});

export default createMapViewStateFromConfiguration;
